import { createSelector } from '@reduxjs/toolkit';

import { resolveDateFormat } from '@iconik-io/core/src/date/resolve_date_format';

import { selectDateTimeFormat } from './select_date_time_format';

export const selectDateTimeProperties = createSelector(
  selectDateTimeFormat,
  resolveDateFormat,
);
